import { formatDisplayTime } from "../../../libs";

export const formatDueDescription = (days: number, time: string) => {
  const dayCount = Math.abs(Number(days));
  const direction = Number(days) < 0 ? "after" : "before";
  return `${dayCount} ${dayCount === 1 ? "day" : "days"} ${direction} the pay day by ${formatDisplayTime(time)}`;
};
